declare const window: any;

const DEFAULT_METADATA = {
  app: 'studio',
};

const intercomAction = (action: string, params = {}, metadata = {}) => {
  window.Intercom?.(action, params, { ...DEFAULT_METADATA, ...metadata });
};

export const intercomBoot = (params) => {
  intercomAction('boot', params);
};

export const intercomUpdate = (params) => {
  intercomAction('update', params);
};

export const intercomShow = () => {
  intercomAction('show');
};

export const trackIntercomEvent = (eventName: string, params = {}) => {
  intercomAction('trackEvent', eventName, params);
};
